import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step1: {
    name: "",
    country_id: "",
    city_id: null,
    product_type_id: 4,
    activity_type_id: null,
    address: "",
    latitude: "",
    longitude: "",
    phone: "",
    has_guide: false,
    max_adults: 1,
    min_adults: 1,
    min_child: 0,
    max_child: 1,
    min_senior: 0,
    max_senior: 0,
    min_baby: 0,
    max_baby: 0,
    guide_in_person: [],
    guide_audio: [],
    guide_information: [],
  },
  step2: {
    short_summary: "",
    detailed_description: "",
    key_points: [""],
    included_items: [""],
    excluded_items: [""],
    not_suitable_for: [""],
    prohibited_items: [""],
    required_items: [""],
    additional_info: "",
    is_food_included: false,
    is_transport_used: false,
    are_drinks_included: false,
    meal_times_id: null,
    meal_category_id: null,
    transport_type_id: null,
    dietary_restrictions: [],
    keyword: [],
  },
  step3: {
    meeting_point: "",
    booking_confirmation_mode: "",
    cancellation_policy_id: null,
    is_private_activity: false,
    min_duration_value: 0,
    min_duration_unit: "hours",
    max_duration_value: 0,
    max_duration_unit: "hours",
    cutoff_time_booking_value: 0,
    cutoff_time_booking_unit: "hours",
    arrival_time_value: 0,
    arrival_time_unit: "hours",
    start_date: "",
    end_date: "",
    has_dropoff_location: false,
    dropoff_location: "",
    schedules: [],
    pricing: {
      is_unified_price: true,
      adult_price: 0,
      child_price: 0,
      baby_price: 0,
      senior_price: 0,
      applicable_days: [],
    },
    charge_service: "5",
    charge_service_type: "out",
  },
};

function deepUpdate(obj, field, value) {
  if (obj && typeof obj === "object") {
    if (field in obj) {
      obj[field] = value;
      return true;
    }
    for (const key of Object.keys(obj)) {
      if (deepUpdate(obj[key], field, value)) {
        return true;
      }
    }
  }
  return false;
}

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    updateActivityStepField: (state, action) => {
      const { field, value } = action.payload;

      if (typeof field !== "string") {
        console.error("updateActivityStepField: invalid field", field);
        return;
      }

      // Dot notation first
      if (field.includes(".")) {
        const keys = field.split(".");
        let target = state;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!target[keys[i]]) return;
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
        return;
      }

      // Deep search fallback
      if (!deepUpdate(state, field, value)) {
        console.warn(`Field '${field}' not found in state`);
      }
    },
    updateActivityStepBulk: (state, action) => {
      const { step, data } = action.payload;
      state[step] = { ...state[step], ...data };
    },
    setActivityProductId: (state, action) => {
      state.product_id = action.payload;
      state.step2.product_id = action.payload;
      state.step3.product_id = action.payload;
    },
    resetActivity: () => initialState,
  },
});

export const {
  updateActivityStepField,
  updateActivityStepBulk,
  setActivityProductId,
  resetActivity,
} = activitySlice.actions;

export default activitySlice.reducer;
